import React from 'react';
import PropTypes from 'prop-types';

import BusComponent from '../../../BusComponent';
import InteractivitySection from '../InteractivitySection';
import LabelOptionsSection from './LabelOptionsSection';
import PointLayerStyleBySection from './PointLayerStyleBySection';
import LegendOptionsSection from '../LegendOptionsSection';

class PointLayerEditor extends BusComponent {
    constructor(props, context) {
        super(props, context);
    }

    onAddPopupContentColumnChange = column => {
        const { mapInstanceId, userDataLayer } = this.props;

        this.emit('ADD_USER_LAYER_POPUP_COLUMN', {
            layerId: userDataLayer.id,
            column,
            mapInstanceId: mapInstanceId,
        });
    };

    onRemovePopupContentColumn = column => {
        const { mapInstanceId, userDataLayer } = this.props;

        this.emit('REMOVE_USER_LAYER_POPUP_COLUMN', {
            layerId: userDataLayer.id,
            column,
            mapInstanceId: mapInstanceId,
        });
    };

    onPopupTitleColumnChange = column => {
        const { mapInstanceId, userDataLayer } = this.props;

        this.emit('UPDATE_USER_LAYER_POPUP_TITLE_COLUMN', {
            layerId: userDataLayer.id,
            column,
            mapInstanceId: mapInstanceId,
        });
    };

    onLabelingColumnChange = pointLabel => {
        const { mapInstanceId, userDataLayer } = this.props;

        this.emit('UPDATE_USER_LAYER_LABELING_COLUMN', {
            layerId: userDataLayer.id,
            pointLabel: pointLabel === 'none' ? undefined : pointLabel,
            mapInstanceId: mapInstanceId,
        });
    };

    onStyleByChange = styleByColumn => {
        const { mapInstanceId, userDataLayer, userDataLayerMetadata } = this.props;

        const discreteProperty = userDataLayerMetadata.discreteProperties.find(
            d => d.title === styleByColumn,
        );
        if (!discreteProperty) return;
        this.emit('UPDATE_USER_LAYER_STYLE_BY_OPTION', {
            mapInstanceId: mapInstanceId,
            layerId: userDataLayer.id,
            styleByColumn,
            dataValues: discreteProperty.data,
        });
    };

    onStyleRuleMarkerStyleChange = (styleRule, newStyle) => {
        const { mapInstanceId, userDataLayer } = this.props;

        this.emit('UPDATE_USER_LAYER_RULE_MARKER_STYLE', {
            layerId: userDataLayer.id,
            styleRule,
            newStyle,
            mapInstanceId: mapInstanceId,
        });
    };

    onStyleRuleVisibilityChange = (styleRule, checked) => {
        const { mapInstanceId, userDataLayer } = this.props;

        this.emit('UPDATE_USER_LAYER_RULE_VISIBILITY', {
            layerId: userDataLayer.id,
            styleRule,
            isHidden: !checked,
            mapInstanceId: mapInstanceId,
        });
    };

    onAllowOverlap = checked => {
        const { mapInstanceId, userDataLayer } = this.props;

        this.emit('UPDATE_USER_LAYER_OVERLAP', {
            layerId: userDataLayer.id,
            allowOverlap: checked,
            mapInstanceId: mapInstanceId,
        });
    };

    onInteractivityFlagChange = checked => {
        const { mapInstanceId, userDataLayer, userDataLayerMetadata } = this.props;

        // when turning on the interactivity flag also set the first column as popup title column
        if (checked)
            this.onPopupTitleColumnChange(userDataLayerMetadata.availableProperties[0]);
        this.emit('UPDATE_USER_LAYER_INTERACTIVITY', {
            layerId: userDataLayer.id,
            interactive: checked,
            mapInstanceId: mapInstanceId,
        });
    };

    render() {
        const { userDataLayer, userDataLayerMetadata } = this.props;

        const discreteProperties = userDataLayerMetadata.discreteProperties.map(c => c.title);
        return (
            <div className="point-layer-editor">
                <div className="point-layer-editor__content">
                    <PointLayerStyleBySection
                        valueColumn={userDataLayer.valueColumn}
                        styleRules={userDataLayer.styleRules}
                        discreteColumns={discreteProperties}
                        allMarkersSame={userDataLayer.valueColumn == null}
                        onStyleRuleVisibilityChange={this.onStyleRuleVisibilityChange}
                        onStyleByChange={this.onStyleByChange}
                        onStyleRuleMarkerStyleChange={this.onStyleRuleMarkerStyleChange}
                    />
                    <hr />
                    <LabelOptionsSection
                        labelingColumn={userDataLayer.pointLabel}
                        onAllowOverlap={this.onAllowOverlap}
                        labelColumns={userDataLayerMetadata.availableProperties}
                        allowOverlap={userDataLayer.allowOverlap}
                        onLabelingColumnChange={this.onLabelingColumnChange}
                    />
                    <hr />
                    <InteractivitySection
                        userDataLayer={userDataLayer}
                        onRemovePopupContentColumn={this.onRemovePopupContentColumn}
                        onPopupTitleColumnChange={this.onPopupTitleColumnChange}
                        onInteractivityFlagChange={this.onInteractivityFlagChange}
                        onAddPopupContentColumnChange={this.onAddPopupContentColumnChange}
                        labelColumns={userDataLayerMetadata.availableProperties}
                    />
                    <hr />
                    <LegendOptionsSection userDataLayer={userDataLayer} />
                </div>
            </div>
        );
    }
}

PointLayerEditor.propTypes = {
    userDataLayer: PropTypes.object.isRequired,
};

PointLayerEditor.defaultProps = {};

export default PointLayerEditor;
